import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { InitiateProcessAction } from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";
import { GetSelected } from "../../../../common/tableHandler/manipulateTable";
import { CAT_WP_CONST } from "../../../../../constants/ActionEnums/CatActionEnums";

class ToevoegenToezichthouder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);
    //** save Toezichthouders
    var toezichthouderToezichthoudersModel = [];
    var toezichthouder = $("input[name=toezichthouder]:checked");
    if (toezichthouder.length > 0 || true) {
      for (let i = 0; i < toezichthouder.length; i++) {
        toezichthouderToezichthoudersModel.push(toezichthouder[i].id);
      }

      const model = {
        action: CAT_WP_CONST.SELECT_SUPERVISORS,
        toezichthouder_identifications: toezichthouderToezichthoudersModel,
        identifications: GetSelected()
      }
      InitiateProcessAction(model, CAT_WP_CONST.END_POINT).then(()=>{
        this.submitCallback()
      }).catch(()=>{
        alert('Something went wrong!')
        $("#cover-spin").hide(0);
      })

      // await GC.StartActivity(
      //   toezichthouderModel,
      //   [window.$catalog_work_plans_selectedIds],
      //   "df461440-0f13-40f8-a8c3-c8b2a6f7c4e8",
      //   this.submitCallback,
      //   window.$catalog_management_units_token
      // );
    } /*else {
      window.$catalog_work_plans_selectedIds.forEach(async (id) => {
        let realtions = await omnimap.GetRelationAction(
          id,
          1,
          30,
          window.$catalog_management_units_token
        );
        await realtions.data.forEach(async (relation) => {
          if (relation.role === "Toezichthouder") {
            GC.sleep(3000).then(async () => {
              await GC.StartActivity(
                { contextIdentification: relation.identification },
                [window.$catalog_work_plans_selectedIds],
                "103ee720-2b6a-48e7-b929-f9b187dd8cc2",
                this.submitCallback,
                window.$catalog_management_units_token
              );
            });

            // await omnimap
            //   .DeleteRelationAction(
            //     relation.identification,
            //     window.$catalog_management_units_token
            //   )
            //   .catch((error) => {
            //     console.log(error);
            //   });
          }
        });
      });
      this.submitCallback();
    }*/
  }
  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#toevoegen_toezichthouder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    $("#toevoegen_toezichthouder").on("show.bs.modal", async function (event) {
      let userRegisteredRoles = await omnimap.GetRelationAction(
        window.$catalog_work_plans_selectedIds[0],
        1,
        30,
        window.$catalog_management_units_token
      );

      await omnimap
        .GetUserByRoleAction(
          1,
          30,
          "toezichthouder",
          window.$catalog_management_units_token
        )
        .then((result) =>
          CallBackFunctions.ToevoegenToezichthouderCallbackForCreate(
            result,
            userRegisteredRoles.data,
            "toevoegen-toezichthouder",
            "toezichthouder"
          )
        );
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="toevoegen_toezichthouder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Toevoegen toezichthouder(s)</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //** Toevoegen toezichthouder(s) */}
                <div className="modal-scroll">
                  <label>Toezichthouders </label>
                  <div id="toevoegen-toezichthouder" className="radio-grp" />
                </div>

                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ToevoegenToezichthouder;
